function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.1367 17.1689C10.6494 17.1689 11.0322 16.7861 11.0322 16.2803V6.42285C11.0322 5.91699 10.6494 5.50684 10.1299 5.50684C9.78809 5.50684 9.53516 5.64355 9.16602 5.99219L6.49316 8.50098C6.45215 8.53516 6.4043 8.55566 6.34961 8.55566H4.52441C3.54004 8.55566 3 9.10254 3 10.1416V12.541C3 13.5801 3.54004 14.1338 4.52441 14.1338H6.34277C6.4043 14.1338 6.45215 14.1475 6.48633 14.1816L9.16602 16.7109C9.50781 17.0322 9.78809 17.1689 10.1367 17.1689ZM13.3291 14.2705C13.6367 14.4619 14.0264 14.3936 14.2383 14.0928C14.7715 13.375 15.0859 12.377 15.0859 11.3311C15.0859 10.2852 14.7715 9.29395 14.2383 8.5625C14.0264 8.26855 13.6367 8.19336 13.3291 8.39844C12.9873 8.61719 12.9189 9.02734 13.1924 9.44434C13.5479 9.9502 13.7393 10.627 13.7393 11.3311C13.7393 12.0352 13.541 12.7051 13.1924 13.2178C12.9258 13.6416 12.9873 14.0449 13.3291 14.2705Z",
  fill: "#EC7963"
});

var SvgVolumeWeak = function SvgVolumeWeak(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVolumeWeak, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volume-weak.dd10a5d8.svg";
export { ForwardRef as ReactComponent };